<template>
  <div class="media-upload">
    <div v-if="value" class="file-row">
      <span class="file-name" :title="value">{{ fileName }}</span>
      <el-button size="mini" type="text" class="danger" @click="clear">移除</el-button>
    </div>
    <el-upload
      action="#"
      :auto-upload="false"
      :show-file-list="false"
      :accept="accept"
      :disabled="uploading"
      :on-change="handleChange"
    >
      <el-button size="small" :loading="uploading">{{ value ? '更换文件' : buttonText }}</el-button>
    </el-upload>
  </div>
</template>

<script>
import { uploadFile } from '@/api/upload'
import { normalizeFileUrl } from '@/utils/fileUrl'

const MAX_VIDEO_SIZE = 500 * 1024 * 1024

export default {
  name: 'MediaUpload',
  props: {
    value: { type: String, default: '' },
    bizType: { type: String, default: 'cms_video' },
    accept: { type: String, default: 'video/*' },
    buttonText: { type: String, default: '上传视频' },
    maxSize: { type: Number, default: MAX_VIDEO_SIZE }
  },
  data() {
    return { uploading: false }
  },
  computed: {
    fileName() {
      if (!this.value) return ''
      const parts = this.value.split('/')
      return parts[parts.length - 1] || this.value
    }
  },
  methods: {
    clear() {
      this.$emit('input', '')
    },
    async handleChange(fileObj) {
      const file = fileObj && fileObj.raw
      if (!file) return
      if (file.size > this.maxSize) {
        this.$message.warning('文件大小超出限制')
        return
      }
      this.uploading = true
      try {
        const result = await uploadFile(file, this.bizType, { useAdmin: true })
        this.$emit('input', normalizeFileUrl(result.url))
        this.$message.success('上传成功')
      } catch (e) {
      } finally {
        this.uploading = false
      }
    }
  }
}
</script>

<style scoped>
.media-upload {
  width: 100%;
}
.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  padding: 4px 8px;
  background: #f5f7fa;
  border-radius: 4px;
}
.file-name {
  flex: 1;
  font-size: 12px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.danger {
  color: #f56c6c;
}
</style>
